export const getProductAttributeFn =
  (keys: string[]) => (attributes?: { [key: string]: string[] }) =>
    getProductAttribute(keys, attributes);

export const getProductAttributeColorCode = getProductAttributeFn([
  'colorcode',
  'colornumber',
  'color',
]);

export const getProductAttributeColor = getProductAttributeFn([
  'colortext',
  'colordescription',
  'color',
]);

export function getProductAttribute(
  keys: string[],
  attributes?: { [key: string]: string[] },
) {
  if (!attributes) {
    return '';
  }

  const result = keys
    .map((key) => attributes?.[key])
    .filter((attribute) => attribute && attribute.length)
    .flat();

  return (result.length ? result[0] : '') ?? '';
}
